<template>
    <BModal ref="modal" :title="$t('onvifDiscovery.title')" centered scrollable no-close-on-backdrop header-class="modal-title" modal-class="no-border-modal" @hidden="onHidden">
        <div v-if="discovering" class="d-flex justify-content-center py-3">
            <div class="spinner-border text-primary" role="status"></div>
        </div>
        <p v-else-if="error" class="text-danger mb-0">{{ error }}</p>
        <p v-else-if="devices.length === 0" class="mb-0">{{ $t('onvifDiscovery.none') }}</p>
        <template v-else>
            <div v-for="(device, index) in devices" :key="index" class="form-check mb-2">
                <input :id="`onvif-device-${index}`" class="form-check-input" type="radio" name="onvif-device" :value="index" v-model="selectedIndex">
                <label class="form-check-label" :for="`onvif-device-${index}`">
                    <span class="fw-bold text-primary">{{ device.label }}</span>
                    <span class="d-block font-13 text-muted">{{ device.details }}</span>
                </label>
            </div>
        </template>
        <template #footer>
            <div class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="close(null)">{{ $t('common.cancel') }}</button>
                <div>
                    <button type="button" class="btn btn-outline-primary" :disabled="discovering" @click="discover">{{ $t('onvifDiscovery.retry') }}</button>
                    <button type="button" class="btn btn-primary ms-2" :disabled="selectedIndex === null" @click="close(devices[selectedIndex])">{{ $t('common.ok') }}</button>
                </div>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue-next';
import { ref } from 'vue';
import { useUserStore } from '@/stores/userStore';

// Runs the ONVIF discovery on the LINK network and lets the installer pick a device.
// show() resolves with the selected DiscoveredCamera, or null when cancelled.
export default {
    name: 'OnvifDiscoveryModal',
    components: {
        BModal
    },
    setup() {
        const userStore = useUserStore();
        const modal = ref(null);
        const discovering = ref(false);
        const error = ref(null);
        const devices = ref([]);
        const selectedIndex = ref(null);
        let target = null;
        let resolver = null;
        let run = 0;

        const discover = async () => {
            const current = ++run;
            discovering.value = true;
            error.value = null;
            devices.value = [];
            selectedIndex.value = null;
            try {
                const result = await userStore.discoverOnvifDevices(target.facilityId, target.hub);
                if (current === run) devices.value = result;
            } catch (message) {
                if (current === run) error.value = message;
            } finally {
                if (current === run) discovering.value = false;
            }
        };

        const show = (facilityId, hub) => {
            target = { facilityId, hub };
            modal.value.show();
            discover();
            return new Promise(resolve => { resolver = resolve; });
        };

        const close = (result) => {
            const resolve = resolver;
            resolver = null;
            run++;
            modal.value.hide();
            if (resolve) resolve(result);
        };

        const onHidden = () => {
            if (resolver) close(null);
        };

        return {
            modal,
            discovering,
            error,
            devices,
            selectedIndex,
            discover,
            show,
            close,
            onHidden,
        };
    }
}
</script>
